'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchSavedItemCountsIfNeeded = exports.isSavedItemCountLoading = exports.getLoadTimeForSavedItemCount = exports.getSavedItemCount = exports.LOAD_SAVED_ITEM_COUNT_SUCCESS = exports.LOAD_SAVED_ITEM_COUNT_REQUEST = exports.LOAD_SAVED_ITEM_COUNT_FAIL = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _api = require('../api');

var _cloneDeep = require('lodash/cloneDeep');

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _reselect = require('reselect');

var _difference = require('lodash/difference');

var _difference2 = _interopRequireDefault(_difference);

var _config = require('./config');

var _ms = require('ms');

var _ms2 = _interopRequireDefault(_ms);

var _union = require('lodash/union');

var _union2 = _interopRequireDefault(_union);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LOAD_SAVED_ITEM_COUNT_FAIL = exports.LOAD_SAVED_ITEM_COUNT_FAIL = 'la/domain/savedItemCount/LOAD_FAIL';
var LOAD_SAVED_ITEM_COUNT_REQUEST = exports.LOAD_SAVED_ITEM_COUNT_REQUEST = 'la/domain/savedItemCount/LOAD_REQUEST';
var LOAD_SAVED_ITEM_COUNT_SUCCESS = exports.LOAD_SAVED_ITEM_COUNT_SUCCESS = 'la/domain/savedItemCount/LOAD_SUCCESS';

var REDUX_STORE_TIME = (0, _ms2.default)('30m');

/* reducer */
var DEFAULT_STATE = {
    byId: {},
    loaded: {},
    loading: []
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var existing = void 0;
    var loaded = void 0;
    var loading = void 0;
    var time = void 0;

    switch (action.type) {
        case LOAD_SAVED_ITEM_COUNT_FAIL:
            return (0, _extends3.default)({}, state, {
                loading: (0, _difference2.default)(state.loading, action.meta.itemIds)
            });
        case LOAD_SAVED_ITEM_COUNT_REQUEST:
            return (0, _extends3.default)({}, state, {
                loading: (0, _union2.default)(state.loading, action.payload)
            });
        case LOAD_SAVED_ITEM_COUNT_SUCCESS:
            existing = (0, _cloneDeep2.default)(state.byId);
            loaded = (0, _extends3.default)({}, state.loaded);
            loading = (0, _cloneDeep2.default)(state.loading);
            time = action.meta.actionTime;

            if (action.payload.savedItemCounts) {
                action.payload.savedItemCounts.forEach(function (x) {
                    existing[x.itemId] = (0, _extends3.default)({}, x);
                    loaded[x.itemId] = time;
                    loading = (0, _difference2.default)(loading, [x.itemId]);
                });
            }

            return (0, _extends3.default)({}, state, {
                byId: existing,
                loaded: loaded,
                loading: loading
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.domain.savedItemCount;
};
var idSelector = function idSelector(state, id) {
    return id;
};

var byIdSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.byId;
});

var loadedSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loaded;
});

var loadingSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loading;
});

// takes in a (state, id) and returns the data
var getSavedItemCount = exports.getSavedItemCount = (0, _reselect.createSelector)([byIdSelector, idSelector], function (byId, id) {
    return byId[id] || { itemId: id, savedCount: 0 };
});

// takes in a (state, id) and returns the load time
var getLoadTimeForSavedItemCount = exports.getLoadTimeForSavedItemCount = (0, _reselect.createSelector)([loadedSelector, idSelector], function (loaded, id) {
    return loaded[id] || 0;
});

// takes in a (state, id) and returns the is loading
var isSavedItemCountLoading = exports.isSavedItemCountLoading = (0, _reselect.createSelector)([loadingSelector, idSelector], function (loading, id) {
    return loading.indexOf(id) !== -1;
});

var shouldFetchSavedItemCount = function shouldFetchSavedItemCount(state, itemId) {
    var data = getSavedItemCount(state, itemId);
    if (data.savedCount !== 0) {
        var loaded = getLoadTimeForSavedItemCount(state, itemId);
        var time = Date.now();
        var diff = time - loaded;
        if (diff < REDUX_STORE_TIME) return false;
    }
    var loading = isSavedItemCountLoading(state, itemId);
    return !loading;
};

var whichSavedItemCountsNeeded = function whichSavedItemCountsNeeded(state, itemIds) {
    return itemIds.filter(function (itemId) {
        return shouldFetchSavedItemCount(state, itemId);
    });
};

/* ACTION CREATORS */
var loadSavedItemCounts = function loadSavedItemCounts(itemIds) {
    return function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, deployment, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            state = getState();
                            deployment = (0, _config.getDeployment)(state);

                            dispatch({
                                payload: itemIds,
                                type: LOAD_SAVED_ITEM_COUNT_REQUEST
                            });
                            _context.next = 6;
                            return _api.SaveItem.fetchSavedItemCounts({ deployment: deployment, itemIds: itemIds });

                        case 6:
                            response = _context.sent;

                            dispatch({
                                meta: { actionTime: Date.now(), itemIds: itemIds },
                                payload: response.data,
                                type: LOAD_SAVED_ITEM_COUNT_SUCCESS
                            });
                            _context.next = 13;
                            break;

                        case 10:
                            _context.prev = 10;
                            _context.t0 = _context['catch'](0);

                            dispatch({
                                error: true,
                                meta: { itemIds: itemIds },
                                payload: _context.t0,
                                type: LOAD_SAVED_ITEM_COUNT_FAIL
                            });

                        case 13:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[0, 10]]);
        }));

        return function (_x3, _x4) {
            return _ref.apply(this, arguments);
        };
    }();
};

var fetchSavedItemCountsIfNeeded = exports.fetchSavedItemCountsIfNeeded = function fetchSavedItemCountsIfNeeded(itemIds) {
    var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    return function (dispatch, getState) {
        var needed = force ? itemIds : whichSavedItemCountsNeeded(getState(), itemIds);
        if (needed.length) {
            return dispatch(loadSavedItemCounts(needed));
        }
        return _promise2.default.resolve();
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/savedItemCount.js
// module id = oIDo
// module chunks = 60